export enum ComponentTheme {
  LIGHT = 'theme-light',
  DARK = 'theme-dark',
  DARK_TRANSPARENT = 'theme-dark-transparent',
  LIGHT_TRANSPARENT = 'theme-light-transparent'
}



// WEBPACK FOOTER //
// ./src/definitions/components.ts